<template>
    <div>
      <div class="sidebar custom-scrollbar" style="box-shadow: none !important;">
        <!--<div class="sidebar-user text-center d-none">
          <div><img class="img-60 rounded-circle" src="../assets/images/user/1.jpg" alt="#">
            <div class="profile-edit"> <router-link to="/users/edit"><feather type="edit"></feather></router-link></div>
          </div>
          <h6 class="mt-3 f-14">ELANA</h6>
          <p>general manager.</p>
        </div>-->
          <ul class="sidebar-menu p-0">
            <li v-for="(menuItem, index) in menuItems" :key="index" :class="'sidebar-menu-item-custom' + ((menuItem.active)?(' sidebar-menu-item-custom-active'):(''))">
               <!-- Sub -->
               <a href="javascript:void(0)" class="sidebar-header" v-if="menuItem.type == 'sub'" @click="setNavActive(menuItem, index);">
                 <feather style="color: white;" :type="menuItem.icon" class="top"></feather><span>{{menuItem.title}}<span :class="'badge badge-pill badge-'+menuItem.badgeType" v-if="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
                 <!--<i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>-->
               </a>

               <!-- Link 
               <router-link :to="menuItem.path" class="sidebar-header" v-if="menuItem.type == 'link'" router-link-exact-active>
                <feather :type="menuItem.icon" class="top"></feather><span>{{menuItem.title}}<span :class="'badge badge-'+menuItem.badgeType+' ml-3'" v-if="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
                 <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
               </router-link>
               <a :href="menuItem.path" class="sidebar-header" v-if="menuItem.type == 'extLink'" @click="setNavActive(menuItem, index)">
                 <feather :type="menuItem.icon" class="top"></feather><span>{{menuItem.title}}<span :class="'badge badge-'+menuItem.badgeType+' ml-3'" v-if="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
                 <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
               </a>
               <a :href="menuItem.path" target="_blank" class="sidebar-header" v-if="menuItem.type == 'extTabLink'" @click="setNavActive(menuItem, index)">
                 <feather :type="menuItem.icon" class="top"></feather><span>{{menuItem.title}}<span :class="'badge badge-'+menuItem.badgeType+' ml-3'" v-if="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
                 <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
               </a>
                <ul class="sidebar-submenu" v-if="menuItem.children">
                  <li v-for="(childrenItem, index) in menuItem.children" :key="index" :class="{'active': childrenItem.active}">

                    <a href="javascript:void(0)" v-if="childrenItem.type == 'sub'" @click="setNavActive(childrenItem, index)">
                       <i class="fa fa-circle"></i>{{childrenItem.title}} <span :class="'badge badge-'+childrenItem.badgeType+' pull-right'" v-if="childrenItem.badgeType">{{childrenItem.badgeValue}}</span>
                       <i class="fa fa-angle-right pull-right" v-if="childrenItem.children"></i>
                    </a>
                    <router-link :to="childrenItem.path" v-if="childrenItem.type == 'link'" router-link-exact-active>
                       <i class="fa fa-circle"></i>{{childrenItem.title}} <span :class="'badge badge-'+childrenItem.badgeType+' pull-right'" v-if="childrenItem.badgeType">{{childrenItem.badgeValue}}</span>
                       <i class="fa fa-angle-right pull-right" v-if="childrenItem.children"></i>
                    </router-link>
                    <a :href="childrenItem.path" v-if="childrenItem.type == 'extLink'">
                       <i class="fa fa-circle"></i>{{childrenItem.title}} <span :class="'badge badge-'+childrenItem.badgeType+' pull-right'" v-if="childrenItem.badgeType">{{childrenItem.badgeValue}}</span>
                       <i class="fa fa-angle-right pull-right" v-if="childrenItem.children"></i>
                    </a>
                    <a :href="childrenItem.path" target="_blank" v-if="childrenItem.type == 'extTabLink'">
                       <i class="fa fa-circle"></i>{{childrenItem.title}} <span :class="'badge badge-'+childrenItem.badgeType+' pull-right'" v-if="childrenItem.badgeType">{{childrenItem.badgeValue}}</span>
                       <i class="fa fa-angle-right pull-right" v-if="childrenItem.children"></i>
                    </a>
                      <ul class="sidebar-submenu" v-if="childrenItem.children">
                        <li v-for="(childrenSubItem, index) in childrenItem.children" :key="index">

                          <router-link :to="childrenSubItem.path" v-if="childrenSubItem.type == 'link'" router-link-exact-active>
                             <i class="fa fa-circle"></i>{{childrenSubItem.title}} <span :class="'badge badge-'+childrenSubItem.badgeType+' pull-right'" v-if="childrenSubItem.badgeType">{{childrenSubItem.badgeValue}}</span>
                             <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                          </router-link>
                          <a :href="childrenSubItem.path" v-if="childrenSubItem.type == 'extLink'">
                             <i class="fa fa-circle"></i>{{childrenSubItem.title}} <span :class="'badge badge-'+childrenSubItem.badgeType+' pull-right'" v-if="childrenSubItem.badgeType">{{childrenSubItem.badgeValue}}</span>
                             <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                          </a>
                          <a :href="childrenSubItem.path" target="_blank" v-if="childrenSubItem.type == 'extTabLink'">
                             <i class="fa fa-circle"></i>{{childrenSubItem.title}} <span :class="'badge badge-'+childrenSubItem.badgeType+' pull-right'" v-if="childrenSubItem.badgeType">{{childrenSubItem.badgeValue}}</span>
                             <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                          </a>
                       </li>
                     </ul>
                  </li>
                </ul>

                -->

            </li>
          </ul>
      </div>
      <!--<div class="sidebar custom-scrollbar" style="box-shadow: none !important;height: 40px !important;">
        <ul class="sidebar-menu p-0">
          <li class="sidebar-menu-item-custom">
            <a href="javascript:void(0)" class="sidebar-header" @click="logout()">
              <feather style="color: white;" type="log-out" class="bottom"></feather>
            </a>
          </li>
        </ul>
      </div>-->
    </div>
</template>
<script>
import { mapState } from "vuex";
import Userauth from '../auth/js/index'

export default {
  name: 'Sidebar',
    data(){
      return{
        width: 0,
        height: 0
      }
    },
  computed: {
    ...mapState({
      menuItems: state => state.menu.data
    })
  },
  mounted () {

    Userauth.cargarMenu(this.menuItems);

    this.menuItems.filter(items => {
      if (items.path === this.$route.path)
        this.$store.dispatch('menu/setActiveRoute', items)
      if (!items.children) return false
      items.children.filter(subItems => {
        if (subItems.path === this.$route.path)
          this.$store.dispatch('menu/setActiveRoute', subItems)
        if (!subItems.children) return false
        subItems.children.filter(subSubItems => {
          if (subSubItems.path === this.$route.path)
            this.$store.dispatch('menu/setActiveRoute', subSubItems)
        })
      })
    })

  },
  methods: {
    setNavActive(item) {
      if (!item.active) {
        this.$store.dispatch('menu/setNavActive', item)
        item.active = true
        if (this.$router.history.current.path != item.path) {
          this.$router.push(item.path)
        }
      } else {
        if (this.$router.history.current.path != item.path) {
          this.$router.push(item.path)
        }
      }
      this.$emit('clicked', false)    
    },
    /*change_password () {
      this.$router.push('/auth/change_password_module')
    },*/
    /*logout: function() {
      try {
        this.$http.secured.delete('/signin')
        .then(response => {
          localStorage.clear()
          this.$router.replace('/auth/login')
        })
        .catch(error => this.showError(error))
      } catch (error) {
        this.showError(error)
      }
    },*/
  }
}
</script>
